import React from 'react';
import { useApplicationState, Borrower } from '../../../state/ApplicationContext';
import { SectionCard } from '../../form/SectionCard';
import { FieldGrid } from '../../form/FieldGrid';
import { TextField } from '../../form/TextField';
import { PhoneField } from '../../form/PhoneField';
import { SelectField } from '../../form/SelectField';
import { YesNoToggle } from '../../form/YesNoToggle';
import { PercentField } from '../../form/PercentField';
import { CurrencyField } from '../../form/CurrencyField';
import { QuickDate } from '../QuickDate';
import { CheckboxField } from '../../form/CheckboxField';
import { ArrowLeftRightIcon, UserPlusIcon } from 'lucide-react';
const MARITAL_STATUSES = [{
  value: 'Single',
  label: 'Single'
}, {
  value: 'Married',
  label: 'Married'
}, {
  value: 'Separated',
  label: 'Separated'
}, {
  value: 'Divorced',
  label: 'Divorced'
}, {
  value: 'Widowed',
  label: 'Widowed'
}];
export function BorrowerManagementSection() {
  const {
    state,
    dispatch
  } = useApplicationState();
  const {
    borrowers
  } = state;
  const updateBorrower = (id: string, data: Partial<Borrower>) => {
    dispatch({
      type: 'UPDATE_BORROWER',
      payload: {
        id,
        data
      }
    });
  };
  const addBorrower = (role: 'co-borrower' | 'additional') => {
    if (borrowers.length >= 5) return;
    dispatch({
      type: 'ADD_BORROWER',
      payload: {
        id: `b${Date.now()}`,
        role,
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        maritalStatus: '',
        spouseOwnership: null,
        participatesOnLoan: true,
        isTitleHolder: true,
        isVeteran: null,
        vaDisabilityPercent: '',
        vaDisabilityIncome: '',
        ssn: '',
        dob: '',
        creditScore: '',
        residencyHistory: []
      }
    });
  };
  const swapBorrowers = (id1: string, id2: string) => {
    dispatch({
      type: 'SWAP_BORROWERS',
      payload: {
        id1,
        id2
      }
    });
  };
  const primary = borrowers.find(b => b.role === 'borrower');
  const coBorrower = borrowers.find(b => b.role === 'co-borrower');
  return <div className="space-y-6" data-id="element-31">
      {borrowers.map((borrower, index) => {
      const isPrimary = borrower.role === 'borrower';
      const title = isPrimary ? 'Primary Borrower' : borrower.role === 'co-borrower' ? 'Co-Borrower' : `Additional Borrower ${index}`;
      return <SectionCard key={borrower.id} data-id="element-32">
            <div className="flex items-center justify-between mb-6" data-id="element-33">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-34">{title}</h3>
              <div className="flex gap-2" data-id="element-35">
                {!isPrimary && primary && <button onClick={() => swapBorrowers(primary.id, borrower.id)} className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-700 font-medium px-3 py-1.5 bg-blue-50 rounded-lg" data-id="element-36">
                    <ArrowLeftRightIcon className="w-4 h-4" data-id="element-37" /> Swap to Primary
                  </button>}
                {!isPrimary && <button onClick={() => dispatch({
              type: 'REMOVE_BORROWER',
              payload: borrower.id
            })} className="text-sm text-red-600 hover:text-red-700 font-medium px-3 py-1.5 bg-red-50 rounded-lg" data-id="element-38">
                    Remove
                  </button>}
              </div>
            </div>

            <div className="space-y-6" data-id="element-39">
              <FieldGrid data-id="element-40">
                <TextField label="First Name" value={borrower.firstName} onChange={v => updateBorrower(borrower.id, {
              firstName: v
            })} data-id="element-41" />
                <TextField label="Last Name" value={borrower.lastName} onChange={v => updateBorrower(borrower.id, {
              lastName: v
            })} data-id="element-42" />
                <TextField label="Email" type="email" value={borrower.email} onChange={v => updateBorrower(borrower.id, {
              email: v
            })} data-id="element-43" />
                <PhoneField label="Phone" value={borrower.phone} onChange={v => updateBorrower(borrower.id, {
              phone: v
            })} data-id="element-44" />
                <TextField label="SSN" value={borrower.ssn} onChange={v => updateBorrower(borrower.id, {
              ssn: v
            })} data-id="element-45" />
                <QuickDate label="Date of Birth" value={borrower.dob} showPresets={false} onChange={v => updateBorrower(borrower.id, {
              dob: v
            })} data-id="element-46" />
              </FieldGrid>

              <div className="border-t border-gray-100 pt-6" data-id="element-47">
                <FieldGrid data-id="element-48">
                  <SelectField label="Marital Status" options={MARITAL_STATUSES} value={borrower.maritalStatus} onChange={v => updateBorrower(borrower.id, {
                maritalStatus: v
              })} data-id="element-49" />
                  {borrower.maritalStatus === 'Married' && <YesNoToggle label="Will spouse be on title?" value={borrower.spouseOwnership} onChange={v => updateBorrower(borrower.id, {
                spouseOwnership: v
              })} data-id="element-50" />}
                </FieldGrid>
              </div>

              <div className="border-t border-gray-100 pt-6" data-id="element-51">
                <FieldGrid data-id="element-52">
                  <YesNoToggle label="Is this borrower a Veteran?" value={borrower.isVeteran} onChange={v => updateBorrower(borrower.id, {
                isVeteran: v
              })} data-id="element-53" />
                  {borrower.isVeteran && <PercentField label="VA Disability Percentage" value={borrower.vaDisabilityPercent} onChange={v => updateBorrower(borrower.id, {
                vaDisabilityPercent: v
              })} data-id="element-54" />}
                  {borrower.isVeteran && parseFloat(borrower.vaDisabilityPercent) > 0 && <CurrencyField label="Monthly VA Disability Income" value={borrower.vaDisabilityIncome} onChange={v => updateBorrower(borrower.id, {
                vaDisabilityIncome: v
              })} data-id="element-55" />}
                </FieldGrid>
              </div>
            </div>
          </SectionCard>;
    })}

      {borrowers.length < 5 && <div className="flex gap-4" data-id="element-56">
          {!coBorrower && <button onClick={() => addBorrower('co-borrower')} className="flex items-center gap-2 px-4 py-3 bg-white border-2 border-dashed border-gray-300 rounded-xl text-gray-600 hover:border-blue-500 hover:text-blue-600 transition-colors font-medium" data-id="element-57">
              <UserPlusIcon className="w-5 h-5" data-id="element-58" /> Add Co-Borrower
            </button>}
          <button onClick={() => addBorrower('additional')} className="flex items-center gap-2 px-4 py-3 bg-white border-2 border-dashed border-gray-300 rounded-xl text-gray-600 hover:border-blue-500 hover:text-blue-600 transition-colors font-medium" data-id="element-59">
            <UserPlusIcon className="w-5 h-5" data-id="element-60" /> Add Additional Borrower
          </button>
        </div>}
    </div>;
}